import { User } from "../api/types";

const LocalStorageService = {
  saveUser: (user: User | null) => {
    window.localStorage.setItem("user", JSON.stringify(user));
  },

  getUser: (): User | null => {
    const user = window.localStorage.getItem("user");

    return user ? JSON.parse(user) : null;
  },

  removeUser: () => {
    window.localStorage.removeItem("user");
  },

  savePreviousURL: (previousURL: string) => {
    window.localStorage.setItem("previousURL", previousURL);
  },

  getPreviousURL: () => {
    return window.localStorage.getItem("previousURL") || "";
  },

  removePreviousURL: () => {
    window.localStorage.removeItem("previousURL");
  },

  getLastContentfulURL: () => {
    return window.localStorage.getItem("lastContentfulURL") || "";
  },

  removeLastContentfulURL: () => {
    window.localStorage.removeItem("lastContentfulURL");
  },

  saveInviteToken: (inviteToken: string) => {
    window.localStorage.setItem("invite", inviteToken);
  },

  getInviteToken: () => {
    return window.localStorage.getItem("invite") || "";
  },

  removeInviteToken: () => {
    window.localStorage.removeItem("invite");
  }
};

export default LocalStorageService;
